// TODO: Time parameters until the logic is implemented
export const VITE_APP_SCOPE = 'openid offline_access';
export const VITE_APP_RESPONSE_TYPE = 'code';
